import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useFormatCurrency = () => {
    const { t } = useTranslation(['common']);

    return useCallback((amount: number) => `${t('common:currency')}${amount.toLocaleString()}`, [t]);
};

export default useFormatCurrency;
